import { MultiTab } from 'components/multiTab';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CompanyTabContent,
  ProfileTabContent,
  UsersTabContent,
} from './TabsContent';
import { useAuth } from 'hooks/contexts/AuthContext';
import { RoleEnum } from 'enums/RoleEnum';

const SettingsPage: FC = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const tabs = [
    {
      title: t('common.profile'),
      component: <ProfileTabContent />,
    },
    ...(user?.role === RoleEnum.ADMINISTRATOR ||
    user?.role === RoleEnum.SYSADMIN
      ? [
          {
            title: t('common.companyInfo'),
            component: <CompanyTabContent />,
          },
          {
            title: t('common.users'),
            component: <UsersTabContent />,
          },
        ]
      : []),
  ];
  return (
    <div>
      <h1 className="mb-6">{t('common.settings')}</h1>
      <MultiTab tabs={tabs} />
    </div>
  );
};
export default SettingsPage;
